import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Icon, Radio, Text, useTheme } from '@Sage/hoi-poi-ui';
import { formatAddress } from 'utils/addresses';

const propTypes = {
    address: PropTypes.object,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onEdit: PropTypes.func,
    selected: PropTypes.bool,
};

const AddressSelectorRow = ({ address, name, onChange, onEdit, selected }) => {
    const theme = useTheme();

    const formattedAddress = useMemo(() => {
        if (!address || !address.address) return '';
        return formatAddress(
            address.address,
            address.address2,
            address.city,
            address.province,
            address.postCode,
            address.country,
            address.idCountry,
        );
    }, [address]);

    const onSelectAddress = useCallback(
        (e) => {
            e?.preventDefault?.();
            e?.stopPropagation?.();
            if (!address) {
                onChange(null, null);
            } else {
                onChange(address.id, address);
            }
        },
        [onChange, address],
    );

    return (
        <div className="fm-shipping-address__selector-row" onClick={onSelectAddress}>
            <div className="fm-shipping-address__selector-row__radio">
                <Radio checked={selected} onChange={onSelectAddress} />
            </div>
            <div className="fm-shipping-address__selector-row__data">
                <div className="fm-shipping-address__selector-row__title">
                    <Text type="body">{name}</Text>
                    {onEdit && (
                        <Icon name="edit" onClick={onEdit} color={theme.colors.actionMinor[500]} />
                    )}
                </div>
                {address && (
                    <Text type="caption" color={theme.colors.textLight.secondary}>
                        {formattedAddress}
                    </Text>
                )}
            </div>
        </div>
    );
};

AddressSelectorRow.displayName = 'AddressSelectorRow';
AddressSelectorRow.propTypes = propTypes;

export default memo(AddressSelectorRow);
